import React, { useContext, useState } from "react";

import TemplatesProduccionList from "../../components/templatesProduccionList/TemplatesProduccionList";
import AbmTemplatesProduccion from "../../components/abmTemplatesProduccion/AbmTemplatesProduccion";

import templateProduccionContext from "../../context/templateProduccionContext/templateProduccionContext";

import './TemplatesProduccion.css';

const TemplatesProduccion = () => {

    const [showABM, setShowABM] = useState(true);
    const [templateToEdit, setTemplateToEdit] = useState({});

    const { templatesProduccionList, actualizarTemplatesProduccionList, eliminarTemplateProduccion } = useContext(templateProduccionContext);

    return (
        <div className="templatesProduccionAbmPage">
            {showABM
                ? <TemplatesProduccionList
                    templatesList={templatesProduccionList}
                    setTemplateToEdit={setTemplateToEdit}
                    setShowABM={setShowABM}
                    eliminarTemplateProduccion={eliminarTemplateProduccion}
                    actualizarTemplatesProduccionList={actualizarTemplatesProduccionList}
                  />
                : <AbmTemplatesProduccion
                    templateToEdit={templateToEdit}
                    setShowABM={setShowABM}
                    setTemplateToEdit={setTemplateToEdit}
                  />
            }
        </div>
    );
};

export default TemplatesProduccion;
